<!--Main-->
<template>
  <div>
    <vxe-toolbar v-if="topBtn.show">
      <template v-slot:buttons>
        <el-button
          v-waves
          :type="topBtn.type"
          :icon="topBtn.icon"
          :disabled="topBtn.disabled"
          :loading="topBtn.loading"
          @click="handleClick(topBtn.event)"
        >{{ topBtn.label }}</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      resizable
      border
      stripe
      show-overflow
      ref="form"
      v-if="data"
      row-id="id"
      style="width: 100%"
      :edit-config="config"
      :edit-rules="rules"
      :data.sync="data"
      @checkbox-change="selectionChange"
      @edit-actived="editActivedEvent"
      @edit-closed="editClosedEvent"
    >
      <vxe-table-column
        v-for="column in fieldList"
        header-align="center"
        align="center"
        :field="column.prop"
        :title="column.label"
        :width="column.width"
        :min-width="column.minWidth"
        :fixed="column.fixed"
        :key="column.prop"
        :type="column.type"
        :formatter="column.formatter"
        :edit-render="column.edit"
        show-overflow-tooltip
      ></vxe-table-column>
      <vxe-table-column
        v-if="handle !== null"
        :key="'handle'"
        :fixed="handle.fixed"
        align="center"
        :title="handle.label"
        :width="handle.width"
      >
        <template v-slot="scope">
          <template v-for="(item, index) in handle.btList">
            <!-- 自定义操作类型 -->
            <slot v-if="item.slot" :name="'bt-' + item.event" :data="{item, row: scope.row}" />
            <!-- 操作按钮 -->
            <el-tooltip
              v-if="item.show"
              :key="index"
              class="item"
              :content="item.label"
              placement="bottom-start"
            >
              <el-button
                plain
                size="mini"
                :type="item.type"
                :icon="item.icon"
                circle
                @click="handleClick(item.event, {...scope.row,$rowIndex:scope.$rowIndex})"
              />
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
export default {
  name: "Main",
  computed: {},
  props: {
    // 列表数据
    data: {
      type: Array,
    },
    // 验证规则
    rules: {
      type: Object,
    },
    refObj: {
      type: Object,
    },
    topBtn: {
      type: Object,
    },
    // 表格字段配置
    fieldList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    config: {
      type: Object,
      default: () => {
        return { "row-id": "row-id", trigger: "click", mode: "cell" };
      },
    },
    // 操作栏配置
    handle: {
      type: Object,
    },
    maxHeight: {
      type: Number,
      default: 500,
    },
    size: {
      type: String,
      default: "mini",
    },
    keyID: String,
  },
  data() {
    return {};
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.form);
        this.checkBox();
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.form);
    this.checkBox();
  },
  //
  methods: {
    editActivedEvent() {},
    //
    editClosedEvent() {},
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    selectionChange(selection) {
      this.$emit("handleEvent", "selectionChange", selection);
    },
    checkBox() {
      this.$nextTick(() => {
        if (this.data) {
          this.data.forEach((item) => {
            this.$refs.form.setSelection(item, item.selected);
          });
        }
      });
    },
  },
};
</script>







// WEBPACK FOOTER //
// src/components/dialog-edit-table.vue